import React from "react"
import "twin.macro"
import { useTranslation } from "next-i18next"

import { Button } from "../formElements/button"
import { useRouter } from "next/router"
import { Question } from "../../graphql/generated/graphql"
interface NextOpenQuestionProps {
  question: Question | null
}

export const NextOpenQuestion = ({ question }: NextOpenQuestionProps) => {
  const { t } = useTranslation("question")
  const router = useRouter()

  const navigateToNextQuestion = async () => {
    await router.push({ pathname: "/q/[id]/", query: { id: question?.id } })
  }

  return (
    <div data-testid="next-question" tw="flex items-center justify-between p-6 bg-black rounded-lg">
      <div tw="text-black font-bold flex flex-col flex-1 rounded-lg">
        <div tw="flex items-center text-lg font-bold text-white">{t("next_question.text")}</div>
      </div>
      <Button action={t("next_question.button")} onClick={navigateToNextQuestion} />
    </div>
  )
}
